// Mock data for Zosia landing page

export const heroData = {
  title: "Zosia mała nauczycielka",
  subtitle: "Bezekranowy robot, który rewolucjonizuje sposób uczenia dzieci",
  description: "Jedyny robot mówiący po polsku pełnymi zdaniami! Nie wymaga internetu ani dodatkowych urządzeń. Gotowy do pracy natychmiast po rozpakowaniu",
  ctaText: "Zamów dla swojej placówki",
  ctaLink: "https://sklep.eduko.pl/products/zosia-mala-nauczycielka-interaktywny-robot-edukacyiny",
  heroImage: "https://sklep.eduko.pl/cdn/shop/files/zosia-product-1.png?v=1694337855&width=1946"
};

export const features = [
  {
    id: 1,
    title: "Nauka Kodowania",
    description: "Dzieci programują robota za pomocą intuicyjnych przycisków. Idealne do nauki algorytmiki i myślenia komputacyjnego - bez ekranów i bez internetu!",
    icon: "Code2",
    image: "https://images.pexels.com/photos/8613089/pexels-photo-8613089.jpeg"
  },
  {
    id: 2,
    title: "9 Języków",
    description: "Mówi PO POLSKU pełnymi zdaniami! Dodatkowo wspiera naukę 8 języków obcych: angielski, francuski, niemiecki, bułgarski, hiszpański, chiński, rosyjski, tajski",
    icon: "Languages",
    image: "https://images.unsplash.com/photo-1588072432836-e10032774350"
  },
  {
    id: 3,
    title: "Metodologia STEAM",
    description: "Kompleksowe podejście - nauka, technologia, inżynieria, sztuka i matematyka. Wspiera podstawę programową i jest łatwa we wdrożeniu",
    icon: "Lightbulb",
    image: "https://images.unsplash.com/photo-1758685734030-a31d96462eec"
  },
  {
    id: 4,
    title: "Praca Indywidualna i Grupowa",
    description: "Doskonała do pracy 1 na 1 w gabinecie logopedycznym, ale też do gier strategicznych w grupach. Aktywizuje wszystkie dzieci!",
    icon: "Palette",
    image: "https://images.unsplash.com/photo-1769720205563-5fd586767067"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Bezekranowe Urządzenie",
    description: "Nie wymaga połączenia z internetem, tabletem ani komputerem. Bezpieczna nauka bez szkodliwego wpływu ekranów. Gotowa do pracy od razu!",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Dla Każdego Typu Zajęć",
    description: "Przedszkola, edukacja wczesnoszkolna, wyższe klasy, gabinety logopedyczne, terapia dzieci ze specjalnymi potrzebami, biblioteki",
    icon: "Users"
  },
  {
    id: 3,
    title: "Wspiera Podstawę Programową",
    description: "Łatwa we wdrożeniu i dostosowaniu. Darmowe scenariusze z projektów Fundacji Eduko pomagają nauczycielom w przygotowaniu zajęć",
    icon: "BookOpen"
  },
  {
    id: 4,
    title: "Nagrywanie Głosu - Logopedia",
    description: "Funkcja nagrywania i odtwarzania dźwięku idealna do ćwiczeń wymowy, terapii logopedycznej i pracy z dziećmi ze SPE",
    icon: "MessageCircle"
  },
  {
    id: 5,
    title: "Aktywizuje i Angażuje",
    description: "Dzieci same chcą się uczyć! Powtarzanie lektury, przygotowanie do sprawdzianu, zadania matematyczne - wszystko staje się grą",
    icon: "Lightbulb"
  },
  {
    id: 6,
    title: "Gry Strategiczne w Grupach",
    description: "Z kilkoma robotami możesz podzielić dzieci na zespoły. Jeździj po mapie świata, Polski, układaj plan wydarzeń, poznawaj historię i geografię",
    icon: "Award"
  }
];

export const packageContent = {
  title: "Co zawiera zestaw?",
  items: [
    "Robot Zosia mała nauczycielka - bezekranowy, mówiący po polsku pełnymi zdaniami",
    "Wymienialne ramiona - do klocków LEGO® i markerów",
    "Instrukcja obsługi PL/EN",
    "Kabel USB-C do ładowania",
    "Dostęp do darmowych scenariuszy z projektów Fundacji Eduko"
  ],
  additionalInfo: "🎁 Rekomendujemy zestaw rozszerzony: \"Koduj z Zosią\" - interaktywne plansze i maty do kodowania",
  price: "999 zł",
  shopLink: "https://sklep.eduko.pl/products/zosia-mala-nauczycielka-interaktywny-robot-edukacyiny",
  rentLink: "https://sklep.eduko.pl/products/zosia-mala-nauczycielka-wypozyczenie-robota",
  kodujLink: "https://sklep.eduko.pl/products/koduj-z-zosia-plansze-interaktywne",
  image: "https://sklep.eduko.pl/cdn/shop/files/zosia-product-1.png?v=1694337855&width=1946"
};

export const testimonials = [
  {
    id: 1,
    name: "Beata Mazurek",
    role: "Nauczycielka przedszkolna, Przedszkole nr 8 w Krakowie",
    content: "Zosia to prawdziwa rewolucja! Dzieci są zachwycone, a darmowe scenariusze z projektów Fundacji Eduko to ogromne wsparcie w przygotowaniu zajęć.",
    rating: 5,
    image: "https://images.pexels.com/photos/8364065/pexels-photo-8364065.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    name: "Piotr Zawadzki",
    role: "Dyrektor Szkoły Podstawowej w Poznaniu",
    content: "Inwestycja w Zosię to najlepsza decyzja dla naszej szkoły. Robot wspiera podstawę programową i jest łatwy we wdrożeniu - działa od razu po rozpakowaniu!",
    rating: 5,
    image: "https://images.pexels.com/photos/5212329/pexels-photo-5212329.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    name: "Magdalena Górska",
    role: "Logopeda, Poradnia Psychologiczno-Pedagogiczna we Wrocławiu",
    content: "Funkcja nagrywania głosu to skarb w pracy logopedycznej! Zosia mówi po polsku naturalnie, dzieci natychmiast się z nią identyfikują i chętnie ćwiczą wymowę.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1717931699152-fbab890f5428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxjaGlsZHJlbiUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3NzA5MzE2ODZ8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Dla jakiej grupy wiekowej przeznaczona jest Zosia?",
    answer: "Zosia jest idealna dla dzieci w wieku przedszkolnym (3-6 lat) oraz wczesnoszkolnym (6-10 lat). Scenariusze zajęć są dostosowane do różnych poziomów zaawansowania."
  },
  {
    id: 2,
    question: "Czy potrzebne są jakieś dodatkowe urządzenia?",
    answer: "Nie! Zosia działa samodzielnie, bez potrzeby podłączania do komputera czy tabletu. Wszystko czego potrzebujesz znajduje się w zestawie. Opcjonalnie możesz dokupić maty do kodowania."
  },
  {
    id: 3,
    question: "Jakie materiały edukacyjne są dołączone?",
    answer: "Do zestawu otrzymujesz dożywotni dostęp do platformy edukacyjnej z gotowymi scenariuszami lekcji, instrukcjami wideo, kartami pracy i materiałami metodycznymi dla nauczycieli."
  },
  {
    id: 4,
    question: "Czy Zosia wymaga obsługi technicznej?",
    answer: "Zosia jest bardzo prosta w obsłudze. Robot jest wytrzymały i zaprojektowany z myślą o intensywnym użytkowaniu w placówkach. Ładowany przez USB-C, gotowy do użycia od razu po rozpakowaniu."
  },
  {
    id: 5,
    question: "Czy możliwa jest prezentacja produktu w naszej placówce?",
    answer: "Tak! Skontaktuj się z nami, a chętnie zorganizujemy prezentację Zosi w Państwa przedszkolu lub szkole. Dostępna jest również opcja wypożyczenia robota na 2 tygodnie za 40 zł."
  },
  {
    id: 6,
    question: "Jakie formy płatności są dostępne dla placówek?",
    answer: "Dla placówek oświatowych oferujemy elastyczne formy płatności, w tym odroczony termin płatności. Szczegóły dostępne po kontakcie z działem handlowym."
  }
];

export const uniqueFeatures = [
  {
    id: 1,
    title: "🗣️ Mówi pełnymi zdaniami PO POLSKU",
    description: "Jako JEDYNY robot edukacyjny Zosia komunikuje się naturalnym językiem polskim - pełnymi zdaniami głosem dziecka. Nie tylko wydaje dźwięki, ale naprawdę ROZMAWIA!",
    highlight: true
  },
  {
    id: 2,
    title: "📚 Bezekranowa - Bez Internetu",
    description: "Nie potrzebuje połączenia z żadnym urządzeniem! Żadnych tabletów, komputerów, aplikacji. Całkowicie bezpieczna dla wzroku dzieci.",
    highlight: true
  },
  {
    id: 3,
    title: "🌍 9 języków (Polski + 8 obcych)",
    description: "Polski pełnymi zdaniami + angielski, francuski, niemiecki, bułgarski, hiszpański, chiński, rosyjski, tajski. To prawdziwy multilingwalny nauczyciel!",
    highlight: false
  },
  {
    id: 4,
    title: "🎯 Natychmiastowa informacja zwrotna",
    description: "Zosia REAGUJE od razu - opowiada historie, ocenia zadania, podaje polecenia. Inne roboty tylko migają diodami.",
    highlight: false
  },
  {
    id: 5,
    title: "🎨 Nieograniczona kreatywność",
    description: "Kompatybilna z klockami LEGO®, Korbo, matami kodującymi, markerami. Na dużej macie podłogowej dzieci mogą narysować trasę po świecie, Polsce, poznawać historię i geografię!",
    highlight: false
  },
  {
    id: 6,
    title: "✅ Gotowa od razu po rozpakowaniu",
    description: "Bez montażu, bez internetu, bez skomplikowanej konfiguracji. Inne roboty wymagają aplikacji i ciągłego połączenia. Zosia działa ZAWSZE!",
    highlight: false
  }
];

export const kodujZZosia = {
  title: "Koduj z Zosią",
  subtitle: "Rozszerz możliwości! Interaktywne plansze i maty do kodowania",
  description: "Zestaw 10 wielkich map edukacyjnych (62x42 cm) + karty poleceń + naklejki. Idealne do pracy grupowej i indywidualnej.",
  price: "799 zł",
  features: [
    "10 interaktywnych map tematycznych",
    "32 karty poleceń do zadań",
    "96 naklejek edukacyjnych",
    "2 puste mapy do własnych projektów",
    "3 maski do personalizacji Zosi"
  ],
  shopLink: "https://sklep.eduko.pl/products/koduj-z-zosia-plansze-interaktywne",
  matLink: "https://sklep.eduko.pl/products/mata-do-kodowania-koduj-z-eduko-duza-120x125cm"
};

export const videos = {
  hero: "https://www.youtube.com/embed/fdHQPkS8wjU",
  tutorials: [
    {
      id: 1,
      title: "Programujemy Zosię po raz pierwszy",
      url: "https://www.youtube.com/embed/gY66tjtP42Y",
      description: "Zobacz jak łatwo rozpocząć przygodę z kodowaniem"
    },
    {
      id: 2,
      title: "Funkcja nagrywania głosu",
      url: "https://www.youtube.com/embed/dVUb5sfRmbc",
      description: "Idealna funkcja dla logopedów i terapeutów"
    },
    {
      id: 3,
      title: "Upiększamy trasę Zosi",
      url: "https://www.youtube.com/embed/52VQeTPWzz0",
      description: "Kreatywne rysowanie tras z markerami"
    }
  ]
};

export const contactInfo = {
  phone: "+48 601 295 295",
  email: "biuro@eduko.pl",
  address: "EDUKO",
  addressFull: "al. Komisji Edukacji Narodowej 36, lok. U207",
  city: "02-797 Warszawa, Polska"
};
